module.exports = __webpack_public_path__ + "staticcomp/img/share.ba19617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/6/share.jpg
// module id = y2WK
// module chunks = 39